import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getString } from '../../helpers/stringHelpers.js';
import withLoader from '../../components/Loader/withLoader.js';

// Actions
import { actions as routingActions } from '../../ducks/routing.js';
import { actions as authActions } from '../../ducks/auth.js';
import { actions as appActions } from '../../ducks/app.js';
import { actions as customerActions } from '../../ducks/customer.js';

// Components
import AppointmentsLayout from '../../components/AppointmentsLayout/AppointmentsLayout';
import AppointmentCard from '../../components/AppointmentCard/AppointmentCard';
import HelpCard from '../../components/HelpCard/HelpCard';
import ReplaceContact from '../../components/Replace/ReplaceContact/ReplaceContact';
import CardSpacer from '../../components/CardSpacer/CardSpacer.js';

// Icons
import InfoIcon from '@material-ui/icons/InfoOutlined';

import theme from '../../theme';
import constants from '../../constants';

import { getLoadedStatus } from '../../helpers/loaderHelpers';
import analyticsApi from '../../api/analytics.js';

class Appointments extends React.Component {
  componentDidMount() {
    const { selectedAppointment, setAppBarTitle } = this.props;
    const stringsComponent = 'appointments';

    setAppBarTitle(getString(stringsComponent, 'TITLE'));

    if (this.refs && selectedAppointment) {
      // Scroll to selected appointment. scrollBy is need due to fixed header.
      // @TODO: Get this working without setTimeout.
      setTimeout(() => {
        const offset =
          window.innerWidth < theme.breakpoints.values.md
            ? constants.HEADER_HEIGHT_MOBILE
            : constants.HEADER_HEIGHT_DESKTOP;
        window.scroll(
          0,
          this.refs['appointment' + selectedAppointment].offsetTop - offset
        );
      }, 0);
    }
  }

  shouldComponentUpdate(nextProps) {
    // Only rerender if not in a unloaded status.
    if (getLoadedStatus(this.getLoadedStatuses(nextProps)) !== 'UNLOADED') {
      return true;
    }
    return false;
  }

  getLoadedStatuses(props = this.props) {
    const { tenancy } = props;
    return [tenancy.loaded];
  }

  render() {
    const {
      tenancy,
      inOutage,
      outageFrom,
      outageTo,
      outageMessage,
      signout,
      getAppointments,
      toggleContactModal,
      selectedAppointment,
      onLoadComplete,
      goDash,
    } = this.props;

    const stringsComponent = 'appointments';
    const tenancyData = tenancy.data;

    let appointmentCards = [];
    tenancyData.hasOwnProperty('currentTenancy') &&
      tenancyData.currentTenancy.hasOwnProperty('appointments') &&
      tenancyData.currentTenancy.appointments.forEach((appointment, i) => {
        appointmentCards.push(
          <React.Fragment key={`appointment-${i}`}>
            {i > 0 && <CardSpacer key={`spacer-${i}`} />}
            <div ref={'appointment' + (i + 1)}>
              <AppointmentCard
                title={appointment.reason}
                description={appointment.reasonDescription}
                date={appointment.date}
                timeFrom={appointment.start}
                timeTo={appointment.end}
                address={tenancyData.currentTenancy.propertyAddress}
                key={`appointmentCard-${i}`}
              />
            </div>
          </React.Fragment>
        );
      });

    const inspectionCard =
      tenancyData.hasOwnProperty('currentTenancy') &&
      tenancyData.currentTenancy.hasOwnProperty('appointments') &&
      tenancyData.currentTenancy.appointments.hasOwnProperty(0) ? (
        <React.Fragment>{appointmentCards}</React.Fragment>
      ) : null;

    const help = portalGuidances.find(
      (guidance) => guidance.Title === stringsComponent
    ) && (
      <HelpCard
        title={getString('help', 'TITLE')}
        subheading={getString('help', 'SUBHEADING')}
        content={
          portalGuidances.find(
            (guidance) => guidance.Title === stringsComponent
          ).Content
        }
        contact={
          portalGuidances.find(
            (guidance) => guidance.Title === stringsComponent
          ).Contact
        }
        faqs={
          portalGuidances.find(
            (guidance) => guidance.Title === stringsComponent
          ).FAQs
        }
        icon={<InfoIcon />}
        section={stringsComponent}
        toggleContactModal={toggleContactModal}
        gaEvent={analyticsApi.event}
      />
    );

    const WrappedAppointmentsLayout = withLoader(AppointmentsLayout);
    return (
      <WrappedAppointmentsLayout
        inspection={inspectionCard}
        help={help}
        loaded={this.getLoadedStatuses()}
        failureText={
          <ReplaceContact
            content={portalContent.APP_ERROR_MESSAGE}
            action={toggleContactModal}
            isLink={true}
          />
        }
        notFoundText={
          <ReplaceContact
            content={portalContent.APP_NOT_FOUND_MESSAGE}
            action={toggleContactModal}
            isLink={true}
          />
        }
        onRefresh={getAppointments}
        onError={signout}
        inOutage={inOutage}
        outageFrom={outageFrom}
        outageTo={outageTo}
        outageMessage={
          outageMessage && (
            <ReplaceContact
              content={outageMessage}
              action={toggleContactModal}
              isLink={true}
            />
          )
        }
        onLoadComplete={onLoadComplete}
        backAction={goDash}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  tenancy: state.customer.tenancy,
  inOutage: state.app.inOutage,
  outageFrom: state.app.outageFrom,
  outageTo: state.app.outageTo,
  outageMessage: state.app.outageMessage,
  selectedAppointment: state.app.selectedAppointment,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...routingActions,
      ...appActions,
      ...authActions,
      ...customerActions,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Appointments);
